<template>
  <div class="drap-upload-wrap">
    <div
      class="ant-upload-list ant-upload-list-text"
      style="margin-bottom: 5px;"
    >
      <div class="" v-for="item in oldFiles" :key="item.id">
        <span style="color: green;"
          ><div
            class="ant-upload-list-item ant-upload-list-item-undefined ant-upload-list-item-list-type-text"
          >
            <div class="ant-upload-list-item-info">
              <span
                ><i
                  aria-label="图标: paper-clip"
                  class="anticon anticon-paper-clip"
                  ><svg
                    viewBox="64 64 896 896"
                    data-icon="paper-clip"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                    focusable="false"
                    class=""
                  >
                    <path
                      d="M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 0 0 174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
                    ></path></svg></i
                ><span
                  title="icon_data_6.png"
                  class="ant-upload-list-item-name"
                  >{{ item.name }}</span
                ><span class="ant-upload-list-item-card-actions "
                  ><a title="删除文件" @click="remove(item.id)"
                    ><i
                      aria-label="图标: delete"
                      tabindex="-1"
                      class="anticon anticon-delete"
                      title="删除文件"
                      ><svg
                        viewBox="64 64 896 896"
                        data-icon="delete"
                        width="1em"
                        height="1em"
                        fill="currentColor"
                        aria-hidden="true"
                        focusable="false"
                        class=""
                      >
                        <path
                          d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                        ></path></svg></i></a></span
              ></span>
            </div></div
        ></span>
      </div>
    </div>
    <a-upload-dragger
      name="files"
      :file-list="files"
      :before-upload="beforeUpload"
      :remove="beforeRemove"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="cloud-upload" />
      </p>
      <p class="ant-upload-text">
        将文件拖到此处，或点击上传
      </p>
      <p class="ant-upload-hint">
        支持单个或批量上传
      </p>
    </a-upload-dragger>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    max: {
      type: Number,
      default: 1
    },
    oldFiles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      files: []
    }
  },
  watch: {
    value(val) {
      this.files = val
    }
  },
  methods: {
    remove(id) {
      this.$emit('remove', id)
    },
    beforeUpload(file) {
      let { max } = this
      const isLt2M = file.size / 1024 / 1024 < max
      if (!isLt2M) {
        this.$message.error(`文件必须小于${max}MB!`)
        return false
      }
      let index = Array.prototype.findIndex.call(
        this.files,
        ele => ele.name === file.name
      )
      if (index === -1) {
        this.files = [...this.files, file]
      }
      this.$emit('input', this.files)
      return false
    },
    beforeRemove(file) {
      let index = Array.prototype.findIndex.call(
        this.files,
        ele => ele.name === file.name
      )
      if (index > -1) {
        this.files.splice(index, 1)
      }
      this.$emit('input', this.files)
    }
  }
}
</script>

<style></style>
